<template>
    <div class="content-subheader">{{ text }}</div>
</template>
<script>
export default {
    name: 'ContentSubheader',
    props: {
        text: String
    }
}
</script>